export function isEverythingSelected(selectionMap) {
    return !Object.values(selectionMap).includes(false);
}
